export default {
    isFetching: false,
    isRequesting: false,
    orders: [],
    customOrders: [],
    order: undefined,
    lastOrder: undefined
};
